import React from "react";
import { css } from "@emotion/react";
import { SearchResultsHeadline } from "./search-results-headline";
import { CSS_MQ } from "../../../styles/breakpoints";
import type { TranslatedValue } from "@swo/storefront";
import { T } from "../../../components/T";

export const SearchResultsViewSectionWithHeadline: React.FC<
  React.PropsWithChildren<{
    headline: TranslatedValue;
    id: string;
  }>
> = props => {
  return (
    <section
      id={props.id}
      css={css`
        margin-bottom: 30px;
        ${CSS_MQ.atLeastMd} {
          margin-bottom: 50px;
        }
      `}
    >
      <SearchResultsHeadline>
        <T>{props.headline}</T>
      </SearchResultsHeadline>

      {props.children}
    </section>
  );
};
